
const webRtcPlayer_ = require("./js/webRtcPlayer.js");

// declare function webRtcPlayer(arg_:string);

const WS_OPEN_STATE = 1;

interface freezeFrame {
    receiving: boolean,
    size: number,
    jpeg: Uint8Array,
    height: number,
    width: number,
    valid: boolean;
}

export const statustype = {
    unknown: 0,
    connect: 1,
    disconnect: 2,
    registered: 3,
    wait: 4,
    error: 999,
} as const;

type statustype = typeof statustype[keyof typeof statustype];
export type modetype = typeof statustype[keyof typeof statustype];

// Must be kept in sync with PixelStreamingProtocol::EToPlayerMsg C++ enum.
const ToClientMessageType = {
    QualityControlOwnership: 0,
    Response: 1,
    Command: 2,
    FreezeFrame: 3,
    UnfreezeFrame: 4,
    VideoEncoderAvgQP: 5,
    LatencyTest: 6,
    InitialSettings: 7,
    FileExtension: 8,
    FileMimeType: 9,
    FileContents: 10
};


// Must be kept in sync with PixelStreamingProtocol::EToUE4Msg C++ enum.
const MessageType = {

    /**********************************************************************/

    /*
     * Control Messages. Range = 0..49.
     */
    IFrameRequest: 0,
    RequestQualityControl: 1,
    FpsRequest: 2,
    AverageBitrateRequest: 3,
    StartStreaming: 4,
    StopStreaming: 5,
    LatencyTest: 6,
    RequestInitialSettings: 7,

    /**********************************************************************/

    /*
     * Input Messages. Range = 50..89.
     */

    // Generic Input Messages. Range = 50..59.
    UIInteraction: 50,
    Command: 51,

    // Keyboard Input Message. Range = 60..69.
    KeyDown: 60,
    KeyUp: 61,
    KeyPress: 62,

    // Mouse Input Messages. Range = 70..79.
    MouseEnter: 70,
    MouseLeave: 71,
    MouseDown: 72,
    MouseUp: 73,
    MouseMove: 74,
    MouseWheel: 75,

    // Touch Input Messages. Range = 80..89.
    TouchStart: 80,
    TouchEnd: 81,
    TouchMove: 82,

    // Gamepad Input Messages. Range = 90..99
    GamepadButtonPressed: 90,
    GamepadButtonReleased: 91,
    GamepadAnalog: 92

    /**************************************************************************/
};

export interface playerStatus {
    onChange(status: statustype): void;       //状態が変化したら受信者に知らせる
}

export interface imageReceiver extends playerStatus {
    onSend(json: string): void;
    onImage(data: string): void;
}

export interface sendStatus extends playerStatus {
    onSend(json: string): void;
}

export type receiver = (playerStatus | imageReceiver);

// WebSocketおよびWebRTCでのPixelStreamingアクセスクラス
//

export class player {

    private webRtcPlayerObj = null;
    private ws: WebSocket = null;

    private print_stats = false;

    private qualityController = false;

    private freezeFrameOverlay: HTMLDivElement = null;
    // private shouldShowPlayOverlay = true;                // playOverlayはアクセスした時に表示される再生ボタン（三角)
    // A freeze frame is a still JPEG image shown instead of the video.
    private freezeFrame: freezeFrame;

    private file = {
        mimetype: "",
        extension: "",
        receiving: false,
        size: 0,
        data: [],
        valid: false,
        timestampStart: undefined
    };

    private VideoEncoderQP = "N/A";

    private responseEventListeners = new Map();

    private status: statustype = 0;
    // private mode: modetype = 0;

    private receivers: receiver[] = [];

    constructor(private ipaddress: string, private port: number = -1) {
        this.status = statustype.unknown;

        this.freezeFrame = {
            receiving: false,
            size: 0,
            jpeg: undefined,
            height: 0,
            width: 0,
            valid: false
        };
    }

    public addReceiver(receiver_: receiver) {
        this.receivers.push(receiver_);
    }

    public removeReceiver(receiver_: receiver) {
        this.receivers.splice(this.receivers.indexOf(receiver_), 1);
    }

    private sendStatus() {
        this.receivers.forEach((receiver_: receiver) => {
            const rev = <playerStatus>receiver_;
            if (rev.onChange) {
                rev.onChange(this.status);
            }
        });
    }

    private sendImage(imagestr: string) {
        this.receivers.forEach((receiver_: receiver) => {
            const rev = <imageReceiver>receiver_;
            if (rev.onImage) {
                rev.onImage(imagestr);
            }
        });
    }

    public load() {
        // this.setupFreezeFrameOverlay();

        const statsDiv = document.getElementById("stats");
        if (statsDiv) {
            statsDiv.innerHTML = 'Not connected';
        }

        // if (!connect_on_load || is_reconnection) {
        //     showConnectOverlay();
        //     invalidateFreezeFrameOverlay();
        //     shouldShowPlayOverlay = true;
        //     resizePlayerStyle();
        // } else {
            this.connect();
        // }
    }

    private wsUrl() {
        if(this.port >= 0){
            return `${this.ipaddress}:${this.port}`;
        }
        return this.ipaddress;
    }

    public connect() {
        "use strict";

        window.WebSocket = window.WebSocket;

        if (!window.WebSocket) {
            alert('Your browser doesn\'t support WebSocket');
            return;
        }

        const url = this.wsUrl();

        console.log(`wss access: ${url}`);

        this.ws = new WebSocket(url);

        this.ws.onopen = (event) => {
            ;
        }

        this.ws.onmessage = (event) => {
            const msg = JSON.parse(event.data);
            if (msg.type === 'config') {
                console.log("%c[Inbound SS (config)]", "background: lightblue; color: black", msg);
                this.onConfig(msg);
            } else if (msg.type === 'playerCount') {
                console.log("%c[Inbound SS (playerCount)]", "background: lightblue; color: black", msg);
            } else if (msg.type === 'offer') {
                console.log("%c[Inbound SS (offer)]", "background: lightblue; color: black", msg);
                this.onWebRtcOffer(msg);
            } else if (msg.type === 'answer') {
                console.log("%c[Inbound SS (answer)]", "background: lightblue; color: black", msg);
                this.onWebRtcAnswer(msg);
            } else if (msg.type === 'iceCandidate') {
                this.onWebRtcIce(msg.candidate);
            } else if(msg.type === 'warning' && msg.warning) {
                console.warn(msg.warning);
            } else {
                console.error("Invalid SS message type", msg.type);
            }
        };

        this.ws.onerror = (event) => {
            console.log(`WS error: ${JSON.stringify(event)}`);
            this.status = statustype.error;
            this.sendStatus();
            this.status = statustype.unknown;

        };

        this.ws.onclose = (event) => {
            console.log(`WS closed: ${JSON.stringify(event.code)} - ${event.reason}`);
            this.ws = undefined;
            // this.is_reconnection = true;

            // destroy `webRtcPlayerObj` if any
            const playerDiv = document.getElementById('player');
            if (playerDiv) {
                playerDiv.removeChild(this.webRtcPlayerObj.video);
            }
            if (this.webRtcPlayerObj) {
                this.webRtcPlayerObj.close();
                this.webRtcPlayerObj = undefined;
            }

            this.showTextOverlay(`Disconnected: ${event.reason}`);
            // setTimeout(this.load, 4000);
            // if (this.mode != statustype.disconnect) {
            //     setTimeout(() => {
            //         this.connect();
            //     }, 4000);
            // }
            this.status = statustype.unknown;
            this.sendStatus();
        };
    }

    public disconnect() {
        this.status = statustype.disconnect;
        if (this.ws) {
            this.ws.close();
        }
    }

    // Config data received from WebRTC sender via the Cirrus web server
    private onConfig(config) {
        const playerDiv = document.getElementById('player');
        this.setupWebRtcPlayer(playerDiv, config);
        // resizePlayerStyle();
    }

    private onWebRtcOffer(webRTCData) {
        this.webRtcPlayerObj.receiveOffer(webRTCData);
        this.setupStats();
    }

    private onWebRtcAnswer(webRTCData) {
        this.webRtcPlayerObj.receiveAnswer(webRTCData);
        this.setupStats();
    }

    private onWebRtcIce(iceCandidate) {
        if (this.webRtcPlayerObj == null) return;
        this.webRtcPlayerObj.handleCandidateFromServer(iceCandidate);
    }

    private setupWebRtcPlayer(htmlElement, config) {
        this.webRtcPlayerObj = new webRtcPlayer_.webRtcPlayer(config);
        // autoPlayAudio = typeof config.autoPlayAudio !== 'undefined' ? config.autoPlayAudio : true;
        if (htmlElement) {
            htmlElement.appendChild(this.webRtcPlayerObj.video);
            htmlElement.appendChild(this.webRtcPlayerObj.audio);
            htmlElement.appendChild(this.freezeFrameOverlay);
        }

        this.webRtcPlayerObj.onWebRtcOffer = (offer) => {
            if (this.ws && this.ws.readyState === WS_OPEN_STATE) {
                console.log("%c[Outbound SS message (offer)]", "background: lightgreen; color: black", offer);

                const offerStr = JSON.stringify(offer);
                this.ws.send(offerStr);
            }
        };

        this.webRtcPlayerObj.onWebRtcCandidate = (candidate) => {
            if (this.ws && this.ws.readyState === WS_OPEN_STATE) {
                this.ws.send(JSON.stringify({
                    type: 'iceCandidate',
                    candidate: candidate
                }));
            }
        };

        this.webRtcPlayerObj.onWebRtcAnswer = (answer) => {
            if (this.ws && this.ws.readyState === WS_OPEN_STATE) {
                console.log("%c[Outbound SS message (answer)]", "background: lightgreen; color: black", answer);

                const answerStr = JSON.stringify(answer);
                this.ws.send(answerStr);
            }
        };

        this.webRtcPlayerObj.onVideoInitialised = () => {
            if (this.ws && this.ws.readyState === WS_OPEN_STATE) {
            //     if (this.shouldShowPlayOverlay) {
            //         this.showPlayOverlay();
            //         this.resizePlayerStyle();
            //     }
            //     else {
            //         this.resizePlayerStyle();
                    this.playStream();
            //     }
            }
        };

        // WebRTC DataChannel 接続時
        this.webRtcPlayerObj.onDataChannelConnected = () => {
            if (this.ws && this.ws.readyState === WS_OPEN_STATE) {
                this.showTextOverlay('WebRTC data channel connected... waiting for video');
                this.requestQualityControl();
                this.status = statustype.connect;
                this.sendStatus();
            }
        };

        this.webRtcPlayerObj.onDataChannelDisconnected = () => {
            this.status = statustype.disconnect;
            this.sendStatus();
        }

        const showFreezeFrame = () => {
            const base64 = btoa(this.freezeFrame.jpeg.reduce((data, byte) => data + String.fromCharCode(byte), ''));
            const imagestr = `data:image/jpeg;base64,${base64}`;
            this.sendImage(imagestr);

            const freezeFrameImage = this.getFreezeImageFrame();
            if (freezeFrameImage == null) return;

            freezeFrameImage.src = imagestr;
            freezeFrameImage.onload = () => {
                this.freezeFrame.height = freezeFrameImage.naturalHeight;
                this.freezeFrame.width = freezeFrameImage.naturalWidth;
                // this.resizeFreezeFrameOverlay();
                // if (this.shouldShowPlayOverlay) {
                //     this.showPlayOverlay();
                //     this.resizePlayerStyle();
                // } else {
                    this.showFreezeFrameOverlay();
                // }
                this.webRtcPlayerObj.setVideoEnabled(false);
            };
        }

        const processFileExtension = (view: Uint8Array) => {
            // Reset file if we got a file message and we are not "receiving" it yet
            if(!this.file.receiving)
            {
                this.file.mimetype = "";
                this.file.extension = "";
                this.file.receiving = true;
                this.file.valid = false;
                this.file.size = 0;
                this.file.data = [];
                this.file.timestampStart = (new Date()).getTime();
                console.log('Received first chunk of file');
            }

            const extensionAsString = new TextDecoder("utf-16").decode(view.slice(1));
            console.log(extensionAsString);
            this.file.extension = extensionAsString;
        }

        const processFileMimeType= (view: Uint8Array) => {
            // Reset file if we got a file message and we are not "receiving" it yet
            if(!this.file.receiving)
            {
                this.file.mimetype = "";
                this.file.extension = "";
                this.file.receiving = true;
                this.file.valid = false;
                this.file.size = 0;
                this.file.data = [];
                this.file.timestampStart = (new Date()).getTime();
                console.log('Received first chunk of file');
            }

            let mimeAsString = new TextDecoder("utf-16").decode(view.slice(1));
            console.log(mimeAsString);
            this.file.mimetype = mimeAsString;
        }


        const processFileContents = (view: Uint8Array) => {
            // If we haven't received the intial setup instructions, return
            if(!this.file.receiving) return;

            // Extract the toal size of the file (across all chunks)
            this.file.size = Math.ceil((new DataView(view.slice(1, 5).buffer)).getInt32(0, true) / 16379 /* The maximum number of payload bits per message*/);

            // Get the file part of the payload
            const fileBytes = view.slice(1 + 4);

            // Append to existing data that holds the file
            this.file.data.push(fileBytes);

            // Uncomment for debug
            console.log(`Received file chunk: ${ this.file.data.length }/${ this.file.size }`);

            if(this.file.data.length === this.file.size)
            {
                this.file.receiving = false;
                this.file.valid = true;
                console.log("Received complete file")
                const transferDuration = ((new Date()).getTime() - this.file.timestampStart);
                const transferBitrate = Math.round(this.file.size * 16 * 1024  / transferDuration);
                console.log(`Average transfer bitrate: ${transferBitrate}kb/s over ${transferDuration / 1000} seconds`);

                // File reconstruction
                /**
                 * Example code to reconstruct the file
                 *
                 * This code reconstructs the received data into the original file based on the mime type and extension provided and then downloads the reconstructed file
                 */
                const received = new Blob(this.file.data, { type: this.file.mimetype })
                const a = document.createElement('a');
                a.setAttribute('href', URL.createObjectURL(received));
                a.setAttribute('download', `transfer.${this.file.extension}`);
                var aj = $(a);
                aj.appendTo('body');
                // aj[0].click();
                aj.remove();
            }
            else if(this.file.data.length > this.file.size)
            {
                this.file.receiving = false;
                console.error(`Received bigger file than advertised: ${this.file.data.length}/${this.file.size}`);
            }
        }

        const processFreezeFrameMessage = (view: Uint8Array) => {
            // Reset freeze frame if we got a freeze frame message and we are not "receiving" yet.
            if (!this.freezeFrame.receiving) {
                this.freezeFrame.receiving = true;
                this.freezeFrame.valid = false;
                this.freezeFrame.size = 0;
                this.freezeFrame.jpeg = undefined;
            }

            // Extract total size of freeze frame (across all chunks)
            this.freezeFrame.size = (new DataView(view.slice(1, 5).buffer)).getInt32(0, true);

            // Get the jpeg part of the payload
            const jpegBytes = view.slice(1 + 4);

            // Append to existing jpeg that holds the freeze frame
            if (this.freezeFrame.jpeg) {
                const jpeg = new Uint8Array(this.freezeFrame.jpeg.length + jpegBytes.length);
                jpeg.set(this.freezeFrame.jpeg, 0);
                jpeg.set(jpegBytes, this.freezeFrame.jpeg.length);
                this.freezeFrame.jpeg = jpeg;
            }
            // No existing freeze frame jpeg, make one
            else {
                this.freezeFrame.jpeg = jpegBytes;
                this.freezeFrame.receiving = true;
                console.log(`received first chunk of freeze frame: ${this.freezeFrame.jpeg.length}/${this.freezeFrame.size}`);
            }

            // Uncomment for debug
            //console.log(`Received freeze frame chunk: ${freezeFrame.jpeg.length}/${freezeFrame.size}`);

            // Finished receiving freeze frame, we can show it now
            if (this.freezeFrame.jpeg.length === this.freezeFrame.size) {
                this.freezeFrame.receiving = false;
                this.freezeFrame.valid = true;
                console.log(`received complete freeze frame ${this.freezeFrame.size}`);
                showFreezeFrame();
            }
            // We received more data than the freeze frame payload message indicate (this is an error)
            else if (this.freezeFrame.jpeg.length > this.freezeFrame.size) {
                console.error(`received bigger freeze frame than advertised: ${this.freezeFrame.jpeg.length}/${this.freezeFrame.size}`);
                this.freezeFrame.jpeg = undefined;
                this.freezeFrame.receiving = false;
            }
        }

        this.webRtcPlayerObj.onNewVideoTrack = (streams) => {
            if (this.webRtcPlayerObj.video && this.webRtcPlayerObj.video.srcObject && this.webRtcPlayerObj.onVideoInitialised) {
                this.webRtcPlayerObj.onVideoInitialised();
            }
            // this.updateStreamList();
        }

        this.webRtcPlayerObj.onDataChannelMessage = (data) => {
            const view = new Uint8Array(data);

            if (view[0] === ToClientMessageType.QualityControlOwnership) {
                const ownership = view[1] === 0 ? false : true;
                console.log("Received quality controller message, will control quality: " + ownership);
                // qualityController = ownership;
                // If we own the quality control, we can't relinquish it. We only lose
                // quality control when another peer asks for it
                // if (qualityControlOwnershipCheckBox !== null) {
                //     qualityControlOwnershipCheckBox.disabled = ownership;
                //     qualityControlOwnershipCheckBox.checked = ownership;
                // }
            } else if (view[0] === ToClientMessageType.Response) {
                const response = new TextDecoder("utf-16").decode(data.slice(1));
                for (let listener of this.responseEventListeners.values()) {
                    listener(response);
                }
            } else if (view[0] === ToClientMessageType.Command) {
                const commandAsString = new TextDecoder("utf-16").decode(data.slice(1));
                console.log(commandAsString);
                const command = JSON.parse(commandAsString);
                if (command.command === 'onScreenKeyboard') {
                    // showOnScreenKeyboard(command);
                }
            } else if (view[0] === ToClientMessageType.FreezeFrame) {
                processFreezeFrameMessage(view);
            } else if (view[0] === ToClientMessageType.UnfreezeFrame) {
                this.invalidateFreezeFrameOverlay();
            } else if (view[0] === ToClientMessageType.VideoEncoderAvgQP) {
                this.VideoEncoderQP = new TextDecoder("utf-16").decode(data.slice(1));
                // console.log(`received VideoEncoderAvgQP ${this.VideoEncoderQP}`);
            } else if (view[0] == ToClientMessageType.LatencyTest) {
                const latencyTimingsAsString = new TextDecoder("utf-16").decode(data.slice(1));
                console.log("Got latency timings from UE.")
                console.log(latencyTimingsAsString);
                const latencyTimingsFromUE = JSON.parse(latencyTimingsAsString);
                if (this.webRtcPlayerObj) {
                    this.webRtcPlayerObj.latencyTestTimings.SetUETimings(latencyTimingsFromUE);
                }
            } else if (view[0] == ToClientMessageType.InitialSettings) {
                const settingsString = new TextDecoder("utf-16").decode(data.slice(1));
                let settingsJSON = JSON.parse(settingsString);

                // if(settingsJSON.PixelStreaming) {
                //     const allowConsoleCommands = settingsJSON.PixelStreaming.AllowPixelStreamingCommands;
                //     if(allowConsoleCommands === false){
                //         // document.getElementById('encoder-min-qp-text').disabled = true;
                //         // document.getElementById('encoder-max-qp-text').disabled = true;
                //         // document.getElementById("webrtc-fps-text").disabled = true;
                //         // document.getElementById("webrtc-min-bitrate-text").disabled = true;
                //         // document.getElementById("webrtc-max-bitrate-text").disabled = true;
                //         // document.getElementById("show-fps-button").disabled = true;
                //         // document.getElementById("encoder-params-submit").disabled = true;
                //         // document.getElementById("webrtc-params-submit").disabled = true;

                //         if(!document.getElementById("warning-elem-webrtc")) {
                //             const warningElem1 = document.createElement("p");
                //             warningElem1.innerText = "(Disabled by -AllowPixelStreamingCommands=false)";
                //             // warningElem1.classList = "subtitle-text";
                //             warningElem1.id = "warning-elem-webrtc";
                //             document.getElementById("webRTCSettingsHeader").appendChild(warningElem1);
                //         }

                //         if(!document.getElementById("warning-elem-encoder")) {
                //             const warningElem2 = document.createElement("p");
                //             warningElem2.innerText = "(Disabled by -AllowPixelStreamingCommands=false)";
                //             // warningElem2.classList = "subtitle-text";
                //             warningElem2.id = "warning-elem-encoder";
                //             document.getElementById("encoderSettingsHeader").appendChild(warningElem2);
                //         }

                //         console.warn("-AllowPixelStreamingCommands=false, sending console commands from browser to UE is disabled, including toggling FPS and changing encoder settings from the browser.")
                //     }
                    // let disableLatencyTest = settingsJSON.PixelStreaming.DisableLatencyTest;
                    // if(disableLatencyTest) {
                    //     document.getElementById("test-latency-button").disabled = true;
                    //     document.getElementById("test-latency-button").title = "Disabled by -PixelStreamingDisableLatencyTester=true";
                    //     console.warn("-PixelStreamingDisableLatencyTester=true, requesting latency report from the the browser to UE is disabled.")
                    // }
                // }
                // if (settingsJSON.Encoder) {
                //     document.getElementById('encoder-min-qp-text').value = settingsJSON.Encoder.MinQP;
                //     document.getElementById('encoder-max-qp-text').value = settingsJSON.Encoder.MaxQP;
                // }
                // if (settingsJSON.WebRTC) {
                //     document.getElementById("webrtc-fps-text").value = settingsJSON.WebRTC.FPS;
                //     // reminder bitrates are sent in bps but displayed in kbps
                //     document.getElementById("webrtc-min-bitrate-text").value = settingsJSON.WebRTC.MinBitrate / 1000;
                //     document.getElementById("webrtc-max-bitrate-text").value = settingsJSON.WebRTC.MaxBitrate / 1000;
                // }
            } else if (view[0] == ToClientMessageType.FileExtension) {
                processFileExtension(view);
            } else if (view[0] == ToClientMessageType.FileMimeType) {
                processFileMimeType(view);
            } else if (view[0] == ToClientMessageType.FileContents) {
                processFileContents(view);
            } else {
                console.error(`unrecognized data received, packet ID ${view[0]}`);
            }
        };

        // return this.webRtcPlayerObj.video;
    }

    private setupStats(){
        this.webRtcPlayerObj.aggregateStats(1 * 1000 /*Check every 1 second*/ );

        const printInterval = 5 * 60 * 1000; /*Print every 5 minutes*/
        let nextPrintDuration = printInterval;

        this.webRtcPlayerObj.onAggregatedStats = (aggregatedStats) => {
            const numberFormat = new Intl.NumberFormat(window.navigator.language, {
                maximumFractionDigits: 0
            });
            const timeFormat = new Intl.NumberFormat(window.navigator.language, {
                maximumFractionDigits: 0,
                minimumIntegerDigits: 2
            });

            // Calculate duration of run
            let runTime = (aggregatedStats.timestamp - aggregatedStats.timestampStart) / 1000;
            const timeValues = [];
            const timeDurations = [60, 60];
            for (let timeIndex = 0; timeIndex < timeDurations.length; timeIndex++) {
                timeValues.push(runTime % timeDurations[timeIndex]);
                runTime = runTime / timeDurations[timeIndex];
            }
            timeValues.push(runTime);

            const runTimeSeconds = timeValues[0];
            const runTimeMinutes = Math.floor(timeValues[1]);
            const runTimeHours = Math.floor(timeValues[2]);

            let receivedBytesMeasurement = 'B';
            let receivedBytes = aggregatedStats.hasOwnProperty('bytesReceived') ? aggregatedStats.bytesReceived : 0;
            const dataMeasurements = ['kB', 'MB', 'GB'];
            for (let index = 0; index < dataMeasurements.length; index++) {
                if (receivedBytes < 100 * 1000)
                    break;
                receivedBytes = receivedBytes / 1000;
                receivedBytesMeasurement = dataMeasurements[index];
            }

            let statsText = '';

            // qualityStatus.className = `${color}Status`;

            statsText += `<div>Duration: ${timeFormat.format(runTimeHours)}:${timeFormat.format(runTimeMinutes)}:${timeFormat.format(runTimeSeconds)}</div>`;
            statsText += `<div>Video Resolution: ${
                aggregatedStats.hasOwnProperty('frameWidth') && aggregatedStats.frameWidth && aggregatedStats.hasOwnProperty('frameHeight') && aggregatedStats.frameHeight ?
                    aggregatedStats.frameWidth + 'x' + aggregatedStats.frameHeight : 'Chrome only'
                }</div>`;
            statsText += `<div>Received (${receivedBytesMeasurement}): ${numberFormat.format(receivedBytes)}</div>`;
            statsText += `<div>Frames Decoded: ${aggregatedStats.hasOwnProperty('framesDecoded') ? numberFormat.format(aggregatedStats.framesDecoded) : 'Chrome only'}</div>`;
            statsText += `<div>Packets Lost: ${aggregatedStats.hasOwnProperty('packetsLost') ? numberFormat.format(aggregatedStats.packetsLost) : 'Chrome only'}</div>`;
            statsText += `<div>Framerate: ${aggregatedStats.hasOwnProperty('framerate') ? numberFormat.format(aggregatedStats.framerate) : 'Chrome only'}</div>`;
            statsText += `<div>Frames dropped: ${aggregatedStats.hasOwnProperty('framesDropped') ? numberFormat.format(aggregatedStats.framesDropped) : 'Chrome only'}</div>`;
            statsText += `<div>Net RTT (ms): ${aggregatedStats.hasOwnProperty('currentRoundTripTime') ? numberFormat.format(aggregatedStats.currentRoundTripTime * 1000) : 'Can\'t calculate'}</div>`;
            statsText += `<div>Browser receive to composite (ms): ${aggregatedStats.hasOwnProperty('receiveToCompositeMs') ? numberFormat.format(aggregatedStats.receiveToCompositeMs) : 'Chrome only'}</div>`;
            statsText += `<div>Bitrate (kbps): ${aggregatedStats.hasOwnProperty('bitrate') ? numberFormat.format(aggregatedStats.bitrate) : 'Chrome only'}</div>`;
            statsText += `<div>Video Quantization Parameter: ${this.VideoEncoderQP}</div>`;

            const statsDiv = document.getElementById("streamingLogContainer");        // webrtc関連ステータス表示
            if (statsDiv) {
                statsDiv.innerHTML = statsText;
            }

            if (this.print_stats) {
                if (aggregatedStats.timestampStart) {
                    if ((aggregatedStats.timestamp - aggregatedStats.timestampStart) > nextPrintDuration) {
                        if (this.ws && this.ws.readyState === WS_OPEN_STATE) {
                            console.log(`-> SS: stats\n${JSON.stringify(aggregatedStats)}`);
                            this.ws.send(JSON.stringify({
                                type: 'stats',
                                data: aggregatedStats
                            }));
                        }
                        nextPrintDuration += printInterval;
                    }
                }
            }
        };

        this.webRtcPlayerObj.latencyTestTimings.OnAllLatencyTimingsReady = (timings) => {

            if (!timings.BrowserReceiptTimeMs) {
                return;
            }

            const latencyExcludingDecode = timings.BrowserReceiptTimeMs - timings.TestStartTimeMs;
            const encodeLatency = timings.UEEncodeMs;
            const uePixelStreamLatency = timings.UECaptureToSendMs;
            const ueTestDuration = timings.UETransmissionTimeMs - timings.UEReceiptTimeMs;
            const networkLatency = latencyExcludingDecode - ueTestDuration;

            //these ones depend on FrameDisplayDeltaTimeMs
            let endToEndLatency = null;
            let browserSideLatency = null;

            if (timings.FrameDisplayDeltaTimeMs && timings.BrowserReceiptTimeMs) {
                endToEndLatency = timings.FrameDisplayDeltaTimeMs + networkLatency + (typeof uePixelStreamLatency === "string" ? 0 : uePixelStreamLatency);
                browserSideLatency = timings.FrameDisplayDeltaTimeMs + (latencyExcludingDecode - networkLatency - ueTestDuration);
            }

            let latencyStatsInnerHTML = '';
            latencyStatsInnerHTML += `<div>Net latency RTT (ms): ${networkLatency.toFixed(2)}</div>`;
            latencyStatsInnerHTML += `<div>UE Encode (ms): ${(typeof encodeLatency === "string" ? encodeLatency : encodeLatency.toFixed(2))}</div>`;
            latencyStatsInnerHTML += `<div>UE Send to capture (ms): ${(typeof uePixelStreamLatency === "string" ? uePixelStreamLatency : uePixelStreamLatency.toFixed(2))}</div>`;
            latencyStatsInnerHTML += `<div>UE probe duration (ms): ${ueTestDuration.toFixed(2)}</div>`;
            latencyStatsInnerHTML += timings.FrameDisplayDeltaTimeMs && timings.BrowserReceiptTimeMs ? `<div>Browser composite latency (ms): ${timings.FrameDisplayDeltaTimeMs.toFixed(2)}</div>` : "";
            latencyStatsInnerHTML += browserSideLatency ? `<div>Total browser latency (ms): ${browserSideLatency.toFixed(2)}</div>` : "";
            latencyStatsInnerHTML += endToEndLatency ? `<div>Total latency (ms): ${endToEndLatency.toFixed(2)}</div>` : "";

            if (document.getElementById("LatencyStats")) {
                document.getElementById("LatencyStats").innerHTML = latencyStatsInnerHTML;
            }
        }
    }

    private getFreezeImageFrame() {
        const freezeFrameOverlay = document.getElementById("freezeFrameOverlay")
        if (freezeFrameOverlay == null) return null;
        return <HTMLImageElement>freezeFrameOverlay.childNodes[0];
    }

    // private getPlayerFrame() {
    //     return undefined;
    // }

    // private showPlayOverlay() {
    //     let img = document.createElement('img');
    //     img.id = 'playButton';
    //     img.src = '/images/Play.png';
    //     img.alt = 'Start Streaming';
    //     this.setOverlay('clickableState', img, event => {
    //         this.playStream();
    //     });
    //     this.shouldShowPlayOverlay = false;
    // }

    // private setOverlay(htmlClass, htmlElement, onClickFunction) {
    //     let videoPlayOverlay = document.getElementById('videoPlayOverlay');
    //     if (!videoPlayOverlay) {

    //         videoPlayOverlay = document.createElement('div');
    //         videoPlayOverlay.id = 'videoPlayOverlay';

    //         const playerDiv = document.getElementById('player');
    //         playerDiv.appendChild(videoPlayOverlay);
    //     }

    //     // Remove existing html child elements so we can add the new one
    //     while (videoPlayOverlay.lastChild) {
    //         videoPlayOverlay.removeChild(videoPlayOverlay.lastChild);
    //     }

    //     if (htmlElement)
    //         videoPlayOverlay.appendChild(htmlElement);

    //     if (onClickFunction) {
    //         videoPlayOverlay.addEventListener('click', function onOverlayClick(event) {
    //             onClickFunction(event);
    //             videoPlayOverlay.removeEventListener('click', onOverlayClick);
    //         });
    //     }

    //     // Remove existing html classes so we can set the new one
    //     let cl = videoPlayOverlay.classList;
    //     for (let i = cl.length - 1; i >= 0; i--) {
    //         cl.remove(cl[i]);
    //     }

    //     videoPlayOverlay.classList.add(htmlClass);
    // }

    // private updateStreamList() {
    //     const streamSelector = document.getElementById('stream-select');
    //     for (let i = streamSelector.options.length - 1; i >= 0; i--) {
    //         streamSelector.remove(i);
    //     }
    //     streamSelector.value = null;
    //     for (const [streamId, stream] of this.webRtcPlayerObj.availableVideoStreams) {
    //         var opt = document.createElement('option');
    //         opt.value = streamId;
    //         opt.innerHTML = streamId;
    //         streamSelector.appendChild(opt);
    //         if (streamSelector.value == null) {
    //             streamSelector.value = streamId;
    //         }
    //     }

    //     this.updateTrackList();
    // }

    private requestQualityControl() {
        if(!this.qualityController){
            this.sendInputData(new Uint8Array([MessageType.RequestQualityControl]).buffer);
        }
    }

    // private setupFreezeFrameOverlay() {
    //     this.freezeFrameOverlay = document.createElement('div');
    //     this.freezeFrameOverlay.id = 'freezeFrameOverlay';
    //     this.freezeFrameOverlay.style.display = 'none';
    //     this.freezeFrameOverlay.style.pointerEvents = 'none';
    //     this.freezeFrameOverlay.style.position = 'absolute';
    //     this.freezeFrameOverlay.style.zIndex = '20';

    //     let freezeFrameImage = document.createElement('img');
    //     freezeFrameImage.style.position = 'absolute';
    //     this.freezeFrameOverlay.appendChild(freezeFrameImage);
    // }

    private showFreezeFrameOverlay() {
        // if (this.freezeFrame.valid) {
        //     // this.freezeFrameOverlay.classList.add("freezeframeBackground");
        //     // this.freezeFrameOverlay.style.display = 'block';
        // }
    }

    private resizePlayerStyleToFillWindow(playerElement) {

        let styleWidth;
        let styleHeight;
        let styleTop;
        let styleLeft;
        let styleCursor = 'default';
        let styleAdditional;

        const videoElement = playerElement.getElementsByTagName("VIDEO");

        // Fill the player display in window, keeping picture's aspect ratio.
        const windowAspectRatio = window.innerHeight / window.innerWidth;
        const playerAspectRatio = playerElement.clientHeight / playerElement.clientWidth;
        // We want to keep the video ratio correct for the video stream
        const videoAspectRatio = videoElement.videoHeight / videoElement.videoWidth;
        if (isNaN(videoAspectRatio)) {
            //Video is not initialised yet so set playerElement to size of window
            styleWidth = window.innerWidth;
            styleHeight = window.innerHeight;
            styleTop = 0;
            styleLeft = 0;
            playerElement.style = "top: " + styleTop + "px; left: " + styleLeft + "px; width: " + styleWidth + "px; height: " + styleHeight + "px; cursor: " + styleCursor + "; " + styleAdditional;
        } else if (windowAspectRatio < playerAspectRatio) {
            // Window height is the constraining factor so to keep aspect ratio change width appropriately
            styleWidth = Math.floor(window.innerHeight / videoAspectRatio);
            styleHeight = window.innerHeight;
            styleTop = 0;
            styleLeft = Math.floor((window.innerWidth - styleWidth) * 0.5);
            //Video is now 100% of the playerElement, so set the playerElement style
            playerElement.style = "top: " + styleTop + "px; left: " + styleLeft + "px; width: " + styleWidth + "px; height: " + styleHeight + "px; cursor: " + styleCursor + "; " + styleAdditional;
        } else {
            // Window width is the constraining factor so to keep aspect ratio change height appropriately
            styleWidth = window.innerWidth;
            styleHeight = Math.floor(window.innerWidth * videoAspectRatio);
            styleTop = Math.floor((window.innerHeight - styleHeight) * 0.5);
            styleLeft = 0;
            //Video is now 100% of the playerElement, so set the playerElement style
            playerElement.style = "top: " + styleTop + "px; left: " + styleLeft + "px; width: " + styleWidth + "px; height: " + styleHeight + "px; cursor: " + styleCursor + "; " + styleAdditional;
        }
    }

    private resizePlayerStyleToActualSize(playerElement) {

        let styleWidth;
        let styleHeight;
        let styleTop;
        let styleLeft;
        let styleCursor = 'default';
        let styleAdditional;

        const videoElement = playerElement.getElementsByTagName("VIDEO");

        if (videoElement.length > 0) {
            // Display image in its actual size
            styleWidth = videoElement[0].videoWidth;
            styleHeight = videoElement[0].videoHeight;
            let Top = Math.floor((window.innerHeight - styleHeight) * 0.5);
            let Left = Math.floor((window.innerWidth - styleWidth) * 0.5);
            styleTop = (Top > 0) ? Top : 0;
            styleLeft = (Left > 0) ? Left : 0;
            //Video is now 100% of the playerElement, so set the playerElement style
            playerElement.style = "top: " + styleTop + "px; left: " + styleLeft + "px; width: " + styleWidth + "px; height: " + styleHeight + "px; cursor: " + styleCursor + "; " + styleAdditional;
        }
    }

    private resizePlayerStyleToArbitrarySize(playerElement) {

        let styleWidth;
        let styleHeight;
        let styleCursor = 'default';
        let styleAdditional;

        let videoElement = playerElement.getElementsByTagName("VIDEO");
        //Video is now 100% of the playerElement, so set the playerElement style
        playerElement.style = "top: 0px; left: 0px; width: " + styleWidth + "px; height: " + styleHeight + "px; cursor: " + styleCursor + "; " + styleAdditional;
    }

    private invalidateFreezeFrameOverlay() {
        if (this.freezeFrameOverlay) {
            this.freezeFrameOverlay.style.display = 'none';
            this.freezeFrameOverlay.classList.remove("freezeframeBackground");
        }
        this.freezeFrame.valid = false;

        if (this.webRtcPlayerObj) {
            this.webRtcPlayerObj.setVideoEnabled(true);
        }
    }

    // private resizeFreezeFrameOverlay() {
        // if (this.freezeFrame.width !== 0 && this.freezeFrame.height !== 0) {
        //     let displayWidth = 0;
        //     let displayHeight = 0;
        //     let displayTop = 0;
        //     let displayLeft = 0;
        //     // const checkBox = document.getElementById('enlarge-display-to-fill-window-tgl');
        //     const playerElement = document.getElementById('player');
        //     // if (checkBox !== null && checkBox.checked) {
        //     //     // We are fitting video to screen, we care about the screen (window) size
        //     //     const windowAspectRatio = window.innerWidth / window.innerHeight;
        //     //     const videoAspectRatio = this.freezeFrame.width / this.freezeFrame.height;
        //     //     if (windowAspectRatio < videoAspectRatio) {
        //     //         displayWidth = window.innerWidth;
        //     //         displayHeight = Math.floor(window.innerWidth / videoAspectRatio);
        //     //         displayTop = Math.floor((window.innerHeight - displayHeight) * 0.5);
        //     //         displayLeft = 0;
        //     //     } else {
        //     //         displayWidth = Math.floor(window.innerHeight * videoAspectRatio);
        //     //         displayHeight = window.innerHeight;
        //     //         displayTop = 0;
        //     //         displayLeft = Math.floor((window.innerWidth - displayWidth) * 0.5);
        //     //     }
        //     // } else {
        //         // Video is coming in at native resolution, we care more about the player size
        //         const playerAspectRatio = playerElement.offsetWidth / playerElement.offsetHeight;
        //         const videoAspectRatio = this.freezeFrame.width / this.freezeFrame.height;
        //         if (playerAspectRatio < videoAspectRatio) {
        //             displayWidth = playerElement.offsetWidth;
        //             displayHeight = Math.floor(playerElement.offsetWidth / videoAspectRatio);
        //             displayTop = Math.floor((playerElement.offsetHeight - displayHeight) * 0.5);
        //             displayLeft = 0;
        //         } else {
        //             displayWidth = Math.floor(playerElement.offsetHeight * videoAspectRatio);
        //             displayHeight = playerElement.offsetHeight;
        //             displayTop = 0;
        //             displayLeft = Math.floor((playerElement.offsetWidth - displayWidth) * 0.5);
        //         }
        //     // }

        //     this.freezeFrameOverlay.style.width = playerElement.offsetWidth + 'px';
        //     this.freezeFrameOverlay.style.height = playerElement.offsetHeight + 'px';
        //     this.freezeFrameOverlay.style.left = 0 + 'px';
        //     this.freezeFrameOverlay.style.top = 0 + 'px';

        //     const freezeFrameImage = this.getFreezeImageFrame();
        //     if (freezeFrameImage == null) return;
        //     freezeFrameImage.style.width = displayWidth + 'px';
        //     freezeFrameImage.style.height = displayHeight + 'px';
        //     freezeFrameImage.style.left = displayLeft + 'px';
        //     freezeFrameImage.style.top = displayTop + 'px';
        // }
    // }

    private playStream() {
        if(this.webRtcPlayerObj && this.webRtcPlayerObj.video) {
            // if(this.webRtcPlayerObj.audio.srcObject && autoPlayAudio) {
            //     // Video and Audio are seperate tracks
            //     this.webRtcPlayerObj.audio.play().then(() => {
            //         this.playVideo();
            //     }).catch((onRejectedReason) => {
            //         console.error(onRejectedReason);
            //         console.log("Browser does not support autoplaying audio without interaction - to resolve this we are going to show the play button overlay.")
            //         this.showPlayOverlay();
            //     });
            // } else {
                // Video and audio are combined in the video element
                this.playVideo();
            // }

            this.requestInitialSettings();
            // this.requestQualityControl();
            this.showFreezeFrameOverlay();
            // this.hideOverlay();
        } else {
            console.error("Could not player video stream because webRtcPlayerObj.video was not valid.")
        }
    }

    private showTextOverlay(text: string) {
        console.log(text);
    }

    // private showTextOverlay(text) {
    //     const textOverlay = document.createElement('div');
    //     textOverlay.id = 'messageOverlay';
    //     textOverlay.innerHTML = text ? text : '';
    //     this.setOverlay('textDisplayState', textOverlay);
    // }

    // private setOverlay(htmlClass, htmlElement, onClickFunction?) {
    //     let videoPlayOverlay = document.getElementById('videoPlayOverlay');
    //     if (!videoPlayOverlay) {
    //         const playerDiv = document.getElementById('player');
    //         videoPlayOverlay = document.createElement('div');
    //         videoPlayOverlay.id = 'videoPlayOverlay';
    //         playerDiv.appendChild(videoPlayOverlay);
    //     }

    //     // Remove existing html child elements so we can add the new one
    //     while (videoPlayOverlay.lastChild) {
    //         videoPlayOverlay.removeChild(videoPlayOverlay.lastChild);
    //     }

    //     if (htmlElement)
    //         videoPlayOverlay.appendChild(htmlElement);

    //     if (onClickFunction) {
    //         videoPlayOverlay.addEventListener('click', function onOverlayClick(event) {
    //             onClickFunction(event);
    //             videoPlayOverlay.removeEventListener('click', onOverlayClick);
    //         });
    //     }

    //     // Remove existing html classes so we can set the new one
    //     const cl = videoPlayOverlay.classList;
    //     for (let i = cl.length - 1; i >= 0; i--) {
    //         cl.remove(cl[i]);
    //     }

    //     videoPlayOverlay.classList.add(htmlClass);
    // }

    private playVideo() {
        this.webRtcPlayerObj.video.play().catch((onRejectedReason) => {
            if(this.webRtcPlayerObj.audio.srcObject) {
                this.webRtcPlayerObj.audio.stop();
            }
            console.error(onRejectedReason);
            console.log("Browser does not support autoplaying video without interaction - to resolve this we are going to show the play button overlay.")
            // this.showPlayOverlay();
        });
    }

    private sendInputData(data) {
        if (this.webRtcPlayerObj) {
            // resetAfkWarningTimer();
            this.webRtcPlayerObj.send(data);
        }
    }

    // A generic message has a type and a descriptor.
    private emitDescriptor(messageType, descriptor) {
        // Convert the dscriptor object into a JSON string.
        const descriptorAsString = JSON.stringify(descriptor);

        // Add the UTF-16 JSON string to the array byte buffer, going two bytes at
        // a time.
        const data = new DataView(new ArrayBuffer(1 + 2 + 2 * descriptorAsString.length));
        let byteIdx = 0;
        data.setUint8(byteIdx, messageType);
        byteIdx++;
        data.setUint16(byteIdx, descriptorAsString.length, true);
        byteIdx += 2;
        for (let i = 0; i < descriptorAsString.length; i++) {
            data.setUint16(byteIdx, descriptorAsString.charCodeAt(i), true);
            byteIdx += 2;
        }
        this.sendInputData(data.buffer);
    }

    // A UI interation will occur when the user presses a button powered by
    // JavaScript as opposed to pressing a button which is part of the pixel
    // streamed UI from the UE4 client.
    public emitUIInteraction(descriptor) {
        this.emitDescriptor(MessageType.UIInteraction, descriptor);
    }

    // A build-in command can be sent to UE4 client. The commands are defined by a
    // JSON descriptor and will be executed automatically.
    // The currently supported commands are:
    //
    // 1. A command to run any console command:
    //    "{ ConsoleCommand: <string> }"
    //
    // 2. A command to change the resolution to the given width and height.
    //    "{ Resolution.Width: <value>, Resolution.Height: <value> } }"
    //
    public emitCommand(descriptor) {
        this.emitDescriptor(MessageType.Command, descriptor);
    }

    private requestInitialSettings() {
        this.sendInputData(new Uint8Array([MessageType.RequestInitialSettings]).buffer);
    }
}
